export interface ArticlePreview {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  keywords: string;
}

export const articlePreviews: ArticlePreview[] = [
  {
    id: 'sicurezza',
    slug: '/articolo/sicurezza-itaobuy-spreadsheet',
    title: 'Itaobuy Spreadsheet è Sicuro? Analisi Completa sulla Sicurezza',
    excerpt: 'Scopri se Itaobuy Spreadsheet è una piattaforma affidabile e sicura. Analizziamo tutti gli aspetti legati alla protezione dei dati e alla trasparenza delle informazioni.',
    keywords: 'itaobuy spreadsheet sicuro, sicurezza acquisti online, affidabilità piattaforma',
  },
  {
    id: 'confronto',
    slug: '/articolo/confronto-itaobuy-spreadsheet',
    title: 'Itaobuy Spreadsheet vs Alternative: Confronto Completo 2026',
    excerpt: 'Un confronto dettagliato tra Itaobuy Spreadsheet e le principali alternative disponibili. Quale strumento offre il miglior rapporto qualità-prezzo per organizzare i tuoi acquisti.',
    keywords: 'confronto itaobuy spreadsheet, alternative fogli calcolo, migliori strumenti shopping',
  },
  {
    id: 'errori',
    slug: '/articolo/errori-comuni-itaobuy-spreadsheet',
    title: '10 Errori Comuni con Itaobuy Spreadsheet e Come Evitarli',
    excerpt: 'Evita gli errori più frequenti quando usi Itaobuy Spreadsheet. Consigli pratici e strategie per ottimizzare la tua esperienza e risparmiare tempo prezioso.',
    keywords: 'errori itaobuy spreadsheet, problemi comuni, consigli pratici shopping',
  },
  {
    id: 'come-usare',
    slug: '/articolo/come-usare-itaobuy-spreadsheet',
    title: 'Come Usare Itaobuy Spreadsheet: Tutorial Passo Dopo Passo',
    excerpt: 'Guida pratica passo dopo passo per imparare a utilizzare Itaobuy Spreadsheet. Dalla ricerca di base alle funzionalità più avanzate, tutto quello che devi sapere.',
    keywords: 'come usare itaobuy spreadsheet, tutorial guida, istruzioni pratiche',
  },
  {
    id: 'faq',
    slug: '/articolo/faq-itaobuy-spreadsheet',
    title: 'FAQ Itaobuy Spreadsheet: Risposte alle Domande più Frequenti',
    excerpt: 'Tutte le risposte alle domande più comuni su Itaobuy Spreadsheet. Dalla registrazione ai costi, dalle categorie alla sicurezza, tutto chiarito in un unico articolo.',
    keywords: 'faq itaobuy spreadsheet, domande frequenti, risposte guida',
  },
  {
    id: 'migliori-prodotti',
    slug: '/articolo/migliori-prodotti-itaobuy-spreadsheet',
    title: 'I Migliori Prodotti su Itaobuy Spreadsheet: Guida alle Categorie Top',
    excerpt: 'Scopri i migliori prodotti disponibili su Itaobuy Spreadsheet. Una panoramica completa delle categorie più popolari e dei prodotti più ricercati dagli utenti italiani.',
    keywords: 'migliori prodotti itaobuy spreadsheet, categorie top, prodotti popolari',
  },
  {
    id: 'gratis',
    slug: '/articolo/spreadsheet-gratis-itaobuy',
    title: 'Itaobuy Spreadsheet è Gratis? Tutto su Costi e Accesso',
    excerpt: 'Itaobuy Spreadsheet è davvero gratuito? Scopri tutti i dettagli su costi, piani di accesso e funzionalità disponibili senza pagare. Informazioni chiare e trasparenti.',
    keywords: 'itaobuy spreadsheet gratis, costi accesso, prezzo piattaforma',
  },
  {
    id: 'avanzata',
    slug: '/articolo/guida-avanzata-itaobuy',
    title: 'Guida Avanzata Itaobuy Spreadsheet: Strategie per Utenti Esperti',
    excerpt: 'Porta la tua esperienza con Itaobuy Spreadsheet al livello successivo. Strategie avanzate, trucchi nascosti e tecniche per massimizzare l\'efficienza delle tue ricerche.',
    keywords: 'guida avanzata itaobuy spreadsheet, strategie esperti, trucchi ottimizzazione',
  },
  {
    id: 'alternative',
    slug: '/articolo/alternative-itaobuy-spreadsheet',
    title: 'Alternative a Itaobuy Spreadsheet: Quali Strumenti Considerare',
    excerpt: 'Esplora le migliori alternative a Itaobuy Spreadsheet disponibili sul mercato. Un\'analisi obiettiva per aiutarti a scegliere lo strumento più adatto alle tue esigenze.',
    keywords: 'alternative itaobuy spreadsheet, strumenti simili, migliori opzioni',
  },
];